
import { Component, Vue } from "vue-property-decorator";
import ImageCompressor from "../ts/ImageCompressor";
import AppButton from "./AppButton.vue";
import ModalCodigo from "./ModalCodigo.vue";

@Component({
  props: {
    showModalImageUp: Boolean,
  },
  components: { ModalCodigo, AppButton },
})
export default class ImageUploader extends Vue {
  imageUrl: string | null = null;
  loading = false;

  closeModal() {
    this.$emit("closeModal");
  }

  deleteImage() {
    this.imageUrl = null;
    this.loading = false;
    this.$emit("deleteImage");
  }

  openCamera() {
    (this.$refs.cameraInput as HTMLInputElement).click();
  }

  selectFromGallery() {
    (this.$refs.galleryInput as HTMLInputElement).click();
  }

  handleFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      this.loading = true;
      this.imageUrl = null;

      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        if (e.target && e.target.result) {
          const originalImageUrl = e.target.result as string;

          setTimeout(() => {
            const image = new Image();
            image.src = originalImageUrl;
            ImageCompressor.compressImage(
              image.src,
              800,
              800,
              "jpeg",
              (compressedImage: string) => {
                this.imageUrl = compressedImage;
                this.$emit("previewFiles", compressedImage);
                this.loading = false;
              }
            );
          }, 500);
        } else {
          this.loading = false;
        }
      };
      reader.readAsDataURL(input.files[0]);
    }
  }
}
